import { BasecaseGateway } from '@scenario/gateways/basecase.gateway';
import { Basecase } from '@scenario/models/basecase.model';
import { environment } from '../../../../../environments/environment';
import { formatGetHeaders } from '@configurations/api-configuration';

export class ApiBasecaseGateway implements BasecaseGateway {
  private readonly basecaseApi = `${environment.backend_url}/api/v1/basecase`;

  async retrieveAll(): Promise<Basecase[]> {
    try {
      const response = await fetch(`${this.basecaseApi}`, await formatGetHeaders());
      return await response.json();
    } catch (error) {
      throw new Error('Error retrieving basecases: ' + error);
    }
  }
}
